import React, { useState } from 'react';

import VehicleDetailsIcon from 'assets/icons/xpo/vehicle-details.svg';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { SectionLine } from '../components/SectionLine';
import { FormikPremiumInput } from 'refactored/features/emergencies/ui/inputs/customInput';
import SpecialLabel from '../components/SpecialLabel';
import SpecialLabelText from '../components/SpecialLabelText';
import { CheckboxsContainer } from '../components/CheckboxsContainer';
import Checkbox from '../components/Checkbox';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import ArrowDown from 'refactored/features/emergencies/ui/icon/arrowDown';

const CustomSectionTitle = styled(SectionTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

const ArrowUp = styled(ArrowDown)`
  transform: rotate(180deg);
`;

export const ServiceTypeSection = withTranslation('Emergencies')(
  ({ ticketFormBodyData, t }) => {
    const { showErrors, isReadOnly, draftErrors, initialValues, values } =
      ticketFormBodyData;

    const [isCollapsed, setIsCollapsed] = useState(true);

    const draftVehicleTypeError =
      !!draftErrors?.order_data?.service_type?.vehicle_type;

    const isVehicleTypeUntouched =
      values.order_data.service_type.vehicle_type ===
      initialValues.order_data.service_type.vehicle_type;

    const hasVehicleTypeError = isVehicleTypeUntouched && draftVehicleTypeError;

    const availableVehicleDetails = [
      {
        value: 'Courtain-sider',
        label: 'Curtain-sider',
      },
      {
        value: 'Hanging garment',
        label: 'Hanging Garment',
      },
      {
        value: 'Box',
        label: 'Box',
      },
      {
        value: 'Reel holder',
        label: 'Reel Holder',
      },
      {
        value: 'Tail lift',
        label: 'Tail Lift',
      },
      {
        value: 'Fridge',
        label: 'Fridge',
      },
      {
        value: 'Retractable roof',
        label: 'Retractable Roof',
      },
    ];

    const translatedAvailableVehicleDetails = availableVehicleDetails.map(
      (details) => ({
        ...details,
        label: t(`available_vehicle_details.${details.label}`),
      })
    );

    const available_vehicle_types = [
      {
        value: 'None',
        label: 'None',
      },
      {
        value: 'Van (max. 800kg)',
        label: 'Van (max. 800kg)',
      },
      {
        value: 'Box Van (max. 800kg)',
        label: 'Box Van (max. 800kg)',
      },
      {
        value: 'Sprinter - Large van (max. 1200kg)',
        label: 'Sprinter - Large van (max. 1200kg)',
      },
      {
        value: 'Light rigid (max. 3.5Tn)',
        label: 'Light rigid (max. 3.5Tn)',
      },
      {
        value: 'Heavy rigid (max. 20Tn)',
        label: 'Heavy rigid (max. 20Tn)',
      },
      {
        value: 'FTL (max. 24Tn) Tautliner Standard',
        label: 'FTL (max. 24Tn) Tautliner Standard',
      },
      {
        value: 'FTL (max. 24Tn) Tautliner Mega',
        label: 'FTL (max. 24Tn) Tautliner Mega',
      },
    ];

    const translatedAvailableVehicleTypes = available_vehicle_types.map(
      (option) => ({
        ...option,
        label: t(`available_vehicle_types.${option.value}`),
      })
    );

    return (
      <SectionContainer>
        <CustomSectionTitle onClick={() => setIsCollapsed(!isCollapsed)}>
          {t('service_type')}
          {isCollapsed ? <ArrowDown /> : <ArrowUp />}
        </CustomSectionTitle>
        {!isCollapsed ? (
          <SectionBody>
            <SectionLine>
              <FormikPremiumInput
                label={t('type')}
                showErrors={showErrors}
                customHasError={hasVehicleTypeError}
                name={`order_data.service_type.vehicle_type`}
                type={'select'}
                isDisabled={isReadOnly}
                isRequired={true}
                availableOptions={translatedAvailableVehicleTypes}
              />
            </SectionLine>
            <SectionLine>
              <SpecialLabel>
                <img alt="Vehicle details icon" src={VehicleDetailsIcon} />
                <SpecialLabelText>{t('vehicle_details')}</SpecialLabelText>
              </SpecialLabel>
            </SectionLine>
            <SectionLine>
              <CheckboxsContainer>
                {translatedAvailableVehicleDetails.map((s) => (
                  <Checkbox
                    name="order_data.service_type.vehicle_details"
                    value={s.value}
                    label={s.label}
                    isDisabled={isReadOnly}
                    backgroundVariant={'grey200'}
                  />
                ))}
              </CheckboxsContainer>
            </SectionLine>
          </SectionBody>
        ) : null}
      </SectionContainer>
    );
  }
);
